import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5bdcda94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = {
  key: 0,
  class: "item"
}
const _hoisted_3 = {
  key: 1,
  class: "item"
}
const _hoisted_4 = { class: "base-form form" }
const _hoisted_5 = { style: {"float":"left"} }
const _hoisted_6 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":".8rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_catalog_picker_component = _resolveComponent("catalog-picker-component")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.isCreatingUserView)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_2, [
                    _createTextVNode(" Новый пользователь "),
                    _createElementVNode("span", null, _toDisplayString(_ctx.ruleForm?.login), 1)
                  ]))
                : (_openBlock(), _createElementBlock("h2", _hoisted_3, [
                    _createTextVNode(" Карточка пользователя "),
                    _createElementVNode("span", null, _toDisplayString(_ctx.user?.login), 1)
                  ]))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_form, {
                model: _ctx.ruleForm,
                ref: "addUserForm",
                "status-icon": "",
                rules: _ctx.rules
              }, {
                default: _withCtx(() => [
                  (!_ctx.isCreatingUserView)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "Дата создания",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.date,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.date) = $event)),
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.isCreatingUserView)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "Логин",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.login,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.login) = $event)),
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isCreatingUserView)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 2,
                        label: "Логин",
                        "label-position": "top",
                        prop: "login"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.login,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.login) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "Пароль",
                    "label-position": "top",
                    prop: "password"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.password,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.password) = $event)),
                        type: "password",
                        "show-password": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Повторите пароль",
                    "label-position": "top",
                    prop: "passwordConfirmation"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.passwordConfirmation,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.passwordConfirmation) = $event)),
                        type: "password"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (!_ctx.isCreatingUserView && _ctx.user?.employee)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 3,
                        label: "Сотрудник",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_link, { type: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.user?.employee?.lastname) + " " + _toDisplayString(_ctx.user?.employee?.firstname?.substring(0,1)), 1)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" ., " + _toDisplayString(_ctx.user?.employee?.position?.name), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isCreatingUserView || (!_ctx.isCreatingUserView && !_ctx.user?.employee))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 4,
                        label: "Сотрудник",
                        "label-position": "top",
                        prop: "employee"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_catalog_picker_component, {
                            ref: "m",
                            auth: "",
                            modelValue: _ctx.ruleForm.employee,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.employee) = $event)),
                            placeholder: "Поиск по инициалам, телефону и email",
                            "search-url": "/api/employees",
                            "catalog-tab": _ctx.employeesCatalogTab,
                            onCatalogItemPicked: _ctx.onEmployeePickedFromCatalog
                          }, {
                            label: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formatEmployeeLabel()), 1)
                            ]),
                            default: _withCtx((scope) => [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(scope.firstname) + " " + _toDisplayString(scope.lastname), 1),
                                _createElementVNode("span", _hoisted_6, _toDisplayString(scope.phone), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "catalog-tab", "onCatalogItemPicked"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "Роли",
                    "label-position": "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        multiple: "",
                        modelValue: _ctx.ruleForm.roles,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.roles) = $event)),
                        placeholder: "Выберите из списка"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userRoles, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              value: item.id,
                              label: item.name
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (!_ctx.isCreatingUserView)
                    ? (_openBlock(), _createBlock(_component_el_form_item, { key: 5 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox, {
                            modelValue: _ctx.ruleForm.blocked,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ruleForm.blocked) = $event)),
                            label: "Пользователь заблокирован",
                            size: "large"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.isCreatingUserView)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 6,
                        label: "Причина блокировки",
                        "label-position": "top",
                        prop: "blockedReason"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            disabled: !_ctx.ruleForm.blocked,
                            modelValue: _ctx.ruleForm.blockedReason,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ruleForm.blockedReason) = $event)),
                            maxlength: "5000",
                            "show-word-limit": "",
                            type: "textarea",
                            placeholder: "Укажите причину блокировки (опционально)"
                          }, null, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      (!_ctx.isCreatingUserView)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            onClick: _ctx.onUpdateUserClick
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Сохранить ")
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.isCreatingUserView)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            type: "primary",
                            onClick: _ctx.onCreateUserClick
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Создать ")
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}